import type { Ref } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import { useIslandHost } from "@frontend/contexts";

import { LocationModal, type LocationModalHandle } from "./LocationModal";
import {
  type LocationModalDataProps,
  locationModalDataSchema,
} from "./LocationModal.schema";
import type { CreatedLocation } from "./types";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "location-modal": {
      props: LocationModalDataProps;
      handle: LocationModalHandle;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-location-modal": HTMLElement & LocationModalHandle;
  }
}

export function RWCLocationModal({
  ref,
}: LocationModalDataProps & { ref?: Ref<LocationModalHandle> }) {
  const host = useIslandHost();

  const handleSubmit = (location: CreatedLocation) => {
    host?.dispatchEvent(
      new CustomEvent("modal:submit", {
        detail: { location },
        bubbles: true,
      }),
    );
  };

  return <LocationModal ref={ref} onSubmit={handleSubmit} />;
}

componentManager.register(
  rwc("location-modal", {
    component: RWCLocationModal,
    dataSchema: locationModalDataSchema,
  }),
);
